class BundleSelector extends HTMLElement {
  constructor() {
    super();

    this.opts = this.querySelectorAll('[data-bundle-selector-opt]');
    this.atc = this.querySelector('[data-bundle-selector-atc]');
    this.quant = this.querySelector('[name="quantity"]');
    this.optCount = 0;

    if (!this.opts) {
      return;
    }

    this.opts = Array.from(this.opts);

    let prevOptIndex = 0;
    this.opts.forEach((opt) => {
      // count number of bundle option groups
      const optIndex = opt.getAttribute('data-bundle-selector-opt');
      if (optIndex !== prevOptIndex) {
        this.optCount++;
        prevOptIndex = optIndex;
      }
      opt.addEventListener('click', this.handleOptClick.bind(this, opt));
    });
  }

  handleOptClick(targetOpt, event) {
    event.preventDefault();

    const optIndex = targetOpt.getAttribute('data-bundle-selector-opt');
    const opts = this.querySelectorAll(`[data-bundle-selector-opt="${optIndex}"]`);
    const optLabel = this.querySelector(`[data-bundle-selector-opt-label="${optIndex}"]`);

    opts.forEach((opt) => {
      opt.classList.remove('active');
    });
    targetOpt.classList.add('active');

    optLabel.innerText = targetOpt.innerText;

    // construct varIds string
    let varIds = [];
    let activeOpt, optVal, quant, maxQuant;
    for (let i = 0; i < this.optCount; i++) {
      activeOpt = this.querySelector(`[data-bundle-selector-opt="${i+1}"].active`);
      if (!activeOpt || !activeOpt.value) {
        continue;
      }

      varIds.push(activeOpt.value);
      quant = parseInt(activeOpt.dataset.maxQuant);

      // set max quant if there is none, or if lower than the current val
      if (
        quant && !maxQuant ||
        quant && quant < maxQuant
      ) {
        maxQuant = quant;
      }
    }

    this.atc.setAttribute('variant-ids', varIds.join(','));

    if (maxQuant && this.quant) {
      this.quant.setAttribute('max', maxQuant);
      if (this.quant.value > maxQuant) this.quant.value = maxQuant;
    }
  }
}

customElements.define('bundle-selector', BundleSelector);
